import { Box } from "@mui/material";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";

type Props = {
  isVisible: boolean;
};

export const DisabledMixpanelIndicator = ({ isVisible }: Props) =>
  isVisible ? (
    <Box
      position="fixed"
      top={8}
      right={28}
      width={16}
      height={16}
      borderRadius="50%"
      sx={{
        transition: "opacity 0.3s ease-in-out",
        zIndex: 9999,
        pointerEvents: "none",
        color: "red",
      }}
    >
      <VideocamOffIcon fontSize="large" />
    </Box>
  ) : null;
